module.exports = __webpack_public_path__ + "img/purple.b965235c.png";